import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";

import { IStoreState } from "../../../../reducers/types";
import {
  getAdultsCount,
  getChildrenCount,
  getFromDate,
  getLocation,
  getPetsCount,
  getUntilDate,
} from "../../../search/reducer";
import { getPremierCollectionShopSelectedAvailability } from "../../../shop/reducer/selectors";
import { TitleSummaryCard } from "./component";

const mapStateToProps = (state: IStoreState) => {
  return {
    lodging: getPremierCollectionShopSelectedAvailability(state),
    fromDate: getFromDate(state),
    untilDate: getUntilDate(state),
    adultsCount: getAdultsCount(state),
    childrenCount: getChildrenCount(state),
    petsCount: getPetsCount(state),
    searchLocation: getLocation(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type TitleSummaryCardConnectorProps = ConnectedProps<typeof connector> &
  RouteComponentProps<any>;

export const ConnectedTitleSummaryCard = withRouter(
  connector(TitleSummaryCard)
);
